import React, { Component } from 'react'
import css from './styles.scss'
import ModifiersEditor from '../ModifiersEditor'

export class ChoiceFromDataSourceColumnNameEditor extends Component {
  constructor ({ variable }) {
    super()
    this.state = {
      selectedDataSource: variable.args[0] || ''
    }
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { selectedDataSource } = this.state
    if (nextProps.report === true && report === false) {
      save(variableName, [selectedDataSource])
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  handleUpdateSelectedDataSource = evt => {
    this.setState({
      selectedDataSource: evt.target.value
    })
  }

  generateDataSourceOptions = () => {
    const { dataSources } = this.props
    const options = [<option key='0' value=''>Select Data Source...</option>]
    let index = 1
    for (const dataSourceId in dataSources) { // eslint-disable-line no-unused-vars
      if (dataSources[dataSourceId].data.length) {
        options.push(<option key={`_${index}`} value={dataSourceId}>{dataSources[dataSourceId].name}</option>)
        index++
      }
    }
    return options
  }

  render () {
    const dataSourceOptions = this.generateDataSourceOptions()
    const { modifiers, instance, instanceModifiers } = this.props

    let instanceInput = null
    if (instance) {
      instanceInput = <ModifiersEditor instanceModifiers={instanceModifiers} isInstance />
    }

    return (
      <div>
        <div className={css.choice}>
          <label>Data Source</label>
          <div className={css.backer}>
            <select
              className={css.select}
              value={this.state.selectedDataSource}
              onChange={this.handleUpdateSelectedDataSource}
            >
              {dataSourceOptions}
            </select>
          </div>
          <ModifiersEditor modifiers={modifiers} />
          {instanceInput}
        </div>
      </div>
    )
  }
}
export default ChoiceFromDataSourceColumnNameEditor



// WEBPACK FOOTER //
// /app/js/components/EditVariable/ChoiceFromDataSourceColumnNameEditor/index.js